<template>
  <div v-if="personID !== null">
    <div class="bg-bluegray-500 p-4 flex flex-col sm:flex-row items-center border-b border-gray-400">
      <div class="flex-grow">
        <div class="text-xl mb-4 font-semibold">
          {{ person.name }}
        </div>
        <span
          v-for="tagID in personTagIDs"
          :key="tagID"
          class="bg-purple-500 text-white py-1 px-2 rounded-sm mr-2 leading-8"
        >
          {{ tags[tagID] }}
        </span>
      </div>
      <div class="mt-4 sm:mt-0 flex flex-col items-start sm:items-end w-full sm:w-auto px-2">
        <div class="mb-2 text-lg">
          <eva-icon
            class="align-middle"
            name="phone-outline"
            fill="#6C63FF"
          />
          {{ person.nationalPhoneNumber }}
        </div>
        <div
          v-if="person.email"
          class="text-lg"
        >
          <eva-icon
            class="align-middle"
            name="email-outline"
            fill="#6C63FF"
          />
          {{ person.email }}
        </div>
      </div>
    </div>
    <div class="sm:grid sm:grid-cols-2 p-4 sm:divide-x">
      <div class="text-lg">
        <div class="font-bold text-xl mb-2">
          Ultimas encuestas:
        </div>
        <div class="space-y-2">
          <div
            v-for="answer in answers"
            :key="answer.id"
            class="flex items-center justify-end sm:justify-start"
          >
            <div class="text-gray-700 mr-4 sm:order-last">
              {{ answer.formattedTimestamp }}
            </div>
            <div :class="`sm:mr-4 w-3 h-3 rounded-full ${answer.riskLevel > 2 ? 'bg-red-500' : 'bg-green-500'}`" />
          </div>
        </div>
      </div>
      <div class="text-lg sm:pl-4">
        <div class="font-bold text-xl mb-2">
          Dosis vacunas:
        </div>
        <div
          v-if="Object.keys(vaccinationData).length === 0"
          class="text-center text-gray-700 py-8"
        >
          <img
            src="@/assets/empty.svg"
            class="w-32 mx-auto opacity-50"
          >
          <div>Aún no hay respuesta</div>
        </div>
        <div
          v-else
          class="space-y-1"
        >
          <div
            v-for="(vaccinationAnswer, index) in vaccinationData.answers"
            :key="index"
            class="flex items-center justify-between border border-gray-400 rounded-lg p-2"
          >
            <div :class="`${vaccinationAnswer.vaccinated ? 'bg-green-500' : 'bg-red-500'} py-1 rounded-md text-white font-bold w-12 text-center`">
              {{ index > 1 ? `R${index - 1}` : ++index }}
            </div>
            <div>
              {{ vaccinationAnswer.vaccinated ? parseDate(vaccinationAnswer.date) : vaccinationAnswer.reason }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { db } from '../utils/firebase'
import moment from 'moment-timezone'

export default {
  components: {
  },
  props: {
    personID: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      answers: [],
      vaccinationData: {},
      dataCollection: null,
      chartOptions: {
        scales: {
          yAxes: [{
            min: new Date(1624986699472),
            type: 'time',
            bounds: 'data',
            time: {
              unit: 'minute',
            },
            distribution: 'linear',
          }],
          xAxes: [{
            type: 'time',
            time: {
              unit: 'day',
            },
            distribution: 'series',
          }],
        },
      },
      binded: false,
      today: moment.tz('America/Bogota').startOf('day'),
    }
  },
  computed: {
    dayLabels () {
      const today = this.today.clone()
      const labels = [today.date()]
      for (let index = 0; index < 15; index++) {
        labels.unshift(today.subtract(1, 'day').date())
      }
      return labels
    },
    personTagIDs () {
      return this.person.tagIDs ? Object.keys(this.person.tagIDs).filter(tagID => typeof this.tags[tagID] !== 'undefined') : []
    },
    person () {
      return this.persons[this.personsIndexes[this.personID]]
    },
    ...mapState({
      persons: state => state.admin.persons,
      personsIndexes: state => state.admin.personsIndexes,
      instanceID: state => state.admin.instanceID,
    }),
    ...mapGetters({
      tags: 'admin/tags',
    }),
  },
  watch: {
    personID: async function (val) {
      console.info(val)
      try {
        this.answers = []
        this.vaccinationData = {}
        const answers = await db.collection('answers').where('personID', '==', this.person.id).orderBy('timestamp', 'desc').limit(5).get()
        if (!answers.empty) {
          this.answers = answers.docs.map(doc => {
            return {
              id: doc.id,
              ...doc.data(),
              // TODO: CAHNGE TIMEZONE for instanceID timeZone
              formattedTimestamp: moment.tz((doc.data().timestamp.toDate()), 'America/Bogota').format('DD/MM/YYYY HH:mm'),
            }
          })
        }
        const vaccinationData = await db.collection('vaccinationData').doc(this.person.id).get()
        if (vaccinationData.exists) {
          this.vaccinationData = {
            ...vaccinationData.data(),
            updated_at_formatted: moment.tz((vaccinationData.data().updated_at.toDate()), 'America/Bogota').format('DD/MM/YYYY HH:mm'),
          }
        }
      } catch (err) {
        console.warn(err)
      }
    },
  },
  methods: {
    parseDate (date) {
      const jsDate = new Date(date)
      return moment.tz(jsDate, 'America/Bogota').format('DD/MM/YYYY')
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
</style>
